function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "13",
  height: "15",
  viewBox: "0 0 13 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.977.775a.455.455 0 00-.45-.018c-.02 0-1.482.67-2.607.67-1.068 0-1.8-.318-2.606-.67C5.452.387 4.57 0 3.277 0 1.777 0 .295.722.239.757a.46.46 0 00-.244.405v12.799a1.04 1.04 0 102.078 0V7.38c.425-.119.715-.215 1.204-.215 1.18 0 1.95.335 2.737.687.806.352 1.65.722 2.888.722 1.462 0 2.962-.722 3.037-.757a.434.434 0 00.244-.387V1.162c0-.158-.075-.3-.206-.387z",
  fill: "#000"
})));